export var SORT_ASCENDING = 'asc';
export var SORT_DESCENDING = 'desc';
export var SORT_NONE = 'none';